"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendToExtension = sendToExtension;
const globalObject_1 = require("./globalObject");
function sendToExtension(type, payload) {
    const callback = globalObject_1.globalObject.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type, payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map